import iconsConfig from './icons-config/icons-config'
// import colors from './themes'
import { defineVuesticConfig } from 'vuestic-ui'

export default defineVuesticConfig({
  // colors,
  icons: iconsConfig,
  breakpoint: {
    enabled: true,
    bodyClass: true,
    thresholds: {
      xs: 0,
      sm: 320,
      md: 640,
      lg: 1024,
      xl: 1440,
    },
  },
  colors: {
    threshold: 216,
    presets: {
      light: {
        primary: "#49b97f",
        active: "#2E9E4B",
        secondary: "#666E75",
        success: "#3D9209",
        info: "#158DE3",
        danger: "#E42222",
        warning: "#FFD43A",
        backgroundPrimary: "#FFFFFF",
        backgroundSecondary: "#FFFFFF",
        backgroundElement: "#ECF0F1",
        backgroundBorder: "#DEE5F2",
        textPrimary: "#262824",
        textInverted: "#FFFFFF",
        shadow: "rgba(0, 0, 0, 0.12)",
        focus: "#49A8FF",
        transparent: "rgba(0, 0, 0, 0)",
        backgroundLanding: "#f4f9fc",
        backgroundLandingBorder: "rgba(155, 179, 206, 0.8)",
        backgroundSidebar: "#ECF0F1"
      }
    },
  },
  components: {
    VaIcon: {
      sizesConfig: {
        defaultSize: 19,
        sizes: {
          small: 14,
          medium: 19,
          large: 26,
        },
      },
    },
    VaModal: {
      mobileFullscreen: false,
      maxHeight: 'calc(100% - 2rem)',
    },
    VaPagination: {
      activeButtonProps: {
        preset: 'primary',
      },
    },
    VaDataTable: {
      disableClientSideSorting: true,
    },
    presets: {
      VaSelect: {
        small: {
          class: 'va-select--small',
          keepAnchorWidth: false,
          placement: 'bottom-end',
          width: 'min(100%, 150px)',
          style:
            '--va-input-wrapper-min-height: 24px; --va-input-wrapper-border-radius: 2px; --va-input-wrapper-width: 100px;',
        },
      },
    },
  },
})
